// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC6nsxYdoSV1v8DipdFDxKcNhbIWLoCyiQ",
  authDomain: "slant-api.firebaseapp.com",
  projectId: "slant-api",
  storageBucket: "slant-api.appspot.com",
  messagingSenderId: "535876220066",
  appId: "1:535876220066:web:45d65b60ba404ab8e893fb"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Export the initialized services
export { auth, db, storage };
